import  * as React from "react";
import { observer } from "mobx-react";
import {IOptimizerTrajectoryViewControlParams} from "./IOptimizerTrajectoryViewControlParams";
import { OptimizedTrajectoryBackground } from "./../OptimizerTrajectoryViewControl/OptimizedTrajectoryBackground/OptimizedTrajectoryBackground";
import { ReportKind } from "Data";

@observer
export class OptimizerTrajectoryViewControl extends React.Component<IOptimizerTrajectoryViewControlParams>{
    constructor(props: IOptimizerTrajectoryViewControlParams) {
        super(props, undefined);
    }

    isReportAppropriate(): boolean {
        return this.props.reportKind === ReportKind.multiGroupReport
            || this.props.reportKind === ReportKind.singleGroupReport
            || this.props.reportKind === ReportKind.puttingMultiGroupReport
            || this.props.reportKind === ReportKind.puttingSingleGroupReport
            || this.props.reportKind === ReportKind.combineTestReport
            || this.props.reportKind === ReportKind.testCenterReport;
    }

    render() {
        
        let isSelectedStrokeData = this.props.selectedStroke  && !this.props.selectedAverage && (this.props.selectedStroke.trajectory == null || this.props.selectedStroke.trajectory.length === 0 || this.props.optimizedData == null || this.props.optimizedData.upperTrajectory == null || this.props.optimizedData.upperTrajectory.length === 0 || this.props.optimizedData.lowerTrajectory == null || this.props.optimizedData.lowerTrajectory.length === 0);
        let isSelectedAverageData = this.props.selectedAverage && !this.props.selectedStroke && (this.props.selectedAverage.trajectory == null || this.props.selectedAverage.trajectory.length === 0 || this.props.optimizedData == null || this.props.optimizedData.upperTrajectory == null || this.props.optimizedData.upperTrajectory.length === 0 || this.props.optimizedData.lowerTrajectory == null || this.props.optimizedData.lowerTrajectory.length === 0);
        
        return <div className="OptimizerTrajectoryViewControl hidden-print">
            {this.isReportAppropriate() && this.props.selectedStrokesGroups.length === 0 &&
                <div className="info-container hidden-print">
                    <p>You have no groups selected.</p>
                    <p>Select a group and a shot to activate the trajectory view.</p>
                </div>
            }
            {(isSelectedStrokeData) &&
                <div className="info-container">
                    <p>There is no trajectory to display.</p>
                </div>
            }
            {(isSelectedAverageData) &&
                <div className="info-container">
                <p>There is no trajectory to display.</p>
                </div>
            }
            <div id="trajectory-container" className="trajectory-side">
                <div className="trajectory-canvas">
                    <OptimizedTrajectoryBackground 
                        optimizedData={this.props.optimizedData} 
                        unitPresentation={this.props.unitPresentation} 
                        selectedStroke={this.props.selectedStroke} 
                        selectedAverage={this.props.selectedAverage} 
                        selectedGroupOfStrokes={this.props.selectedGroupOfStrokes} />
                </div>
            </div>
        </div >;
    }
}
